import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { RequestParameter, Properties } from '../../utils/model';

export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const [step, setStep] = useState(Steps.roomNameStep);

  const [name, setName] = useState<string>(user?.displayName || '');
  const [roomName, setRoomName] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();
  const rp = RequestParameter.getInstance();
  const props = Properties.getInstance();

  useEffect(() => {
    const search = window.location.search;
    const query = new URLSearchParams(search);
    let name1 = query.get('name') || query.get('bmFtZQ');
    let roomName1 = query.get('room') || query.get('cm9vbQ');
    let email = query.get('email') || query.get('ZW1haWw');
    let video = query.get('video') || query.get('dmlkZW8');
    let calling = query.get('calling') || query.get('Y2FsbGluZw');

    if (email && query.get('ZW1haWw')) {
      email = atob(email);
    }
    email = !email ? '' : email;

    if (query.get('dmlkZW8') && video) {
      video = atob(video);
    }
    video = !video ? 'no' : video;

    if (calling) {
      if (query.get('Y2FsbGluZw')) {
        calling = atob(calling);
      }
    } else {
      calling = '';
    }

    if (name1 && roomName1) {
      if (query.get('bmFtZQ')) {
        name1 = atob(name1);
        roomName1 = atob(roomName1);
      }
      rp.setAll(roomName1, name1, email, video, calling);

      setRoomName(roomName1);
      setName(name1);
      setStep(Steps.deviceSelectionStep);
    }

    if (window.location.origin.includes('localhost')) {
      props.put('baseUrl', 'http://localhost:8900/twilio');
    } else {
      props.put('baseUrl', window.location.origin);
    }
  }, [user, URLRoomName]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.
    // @ts-ignore
    if (!window.location.origin.includes('twil.io') && !window.STORYBOOK_ENV) {
      window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    }
    setStep(Steps.deviceSelectionStep);
  };

  return (
    <IntroContainer>
      <MediaErrorSnackbar error={mediaError} />
      {step === Steps.roomNameStep && (
        <RoomNameScreen
          name={name}
          roomName={roomName}
          setName={setName}
          setRoomName={setRoomName}
          handleSubmit={handleSubmit}
        />
      )}

      {step === Steps.deviceSelectionStep && (
        <DeviceSelectionScreen name={name} roomName={roomName} setStep={setStep} />
      )}
    </IntroContainer>
  );
}
